/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type ItemNodeItemTypeEnum = typeof ItemNodeItemTypeEnum[keyof typeof ItemNodeItemTypeEnum];


export const ItemNodeItemTypeEnum = {
  FOLDER: 'folder',
  WORD_CLOUDS_WORD_CLOUD: 'Tools::WordClouds::WordCloud',
  AI_ASSISTANT: 'Tools::Ai::Assistant',
  AUDIO_RECORDER_FILE: 'AudioRecorder::File',
  CLASSROOM_SCREEN_SCREEN: 'Tools::ClassroomScreen::Screen',
  FILE_SHARING_FILE: 'Tools::FileSharing::File',
  PINBOARD_BOARD: 'Tools::Pinboard::Board',
  SCREEN_RECORDER_FILE: 'ScreenRecorder::File',
  SURVEYS_SURVEY: 'Tools::Surveys::Survey',
  TEXT_EDITOR_DOCUMENT: 'Tools::TextEditor::Document',
  VIDEO_RECORDER_FILE: 'VideoRecorder::File',
  WEBSITE_PAGE: 'Tools::Website::Page',
  WORKSHEET_WORKSHEET: 'Tools::Worksheet::Worksheet',
  AI_FEEDBACK: 'Tools::Ai::Feedback',
  PUPIL_FEEDBACK_ASSIGNMENT: 'Tools::PupilFeedback::Assignment',
  AI_IMAGE: 'Tools::Ai::Image',
  LINK_SHORTENER_LINK: 'LinkShortener::Link',
} as const;
